import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { AssignProfileTag, AssignStreamTag } from "../../DAL/create";
import {
  updateAssignTagsData,
  updateProdileAssignTagsData,
} from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

export default function AssignProfileTagDialog({ open, setOpen, data, type }) {
  console.log(data, "aslkdjlaksjdaj");
  const [value, setValue] = React.useState(dayjs());
  const [inputs, setInputs] = useState({
    userId: "",
    tagId: "",
    status: "",
  });
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      userRid: inputs?.userId,
      tagId: inputs?.tagId,
    };

    const formDataUpdate = {
      ...formData,
      status: inputs?.status,
    };

    const resp =
      type == "Add"
        ? await AssignProfileTag(formData)
        : await updateProdileAssignTagsData(data?.id, formDataUpdate);
    if (
      type == "Add"
        ? resp?.data?.statusCode == 201
        : resp?.data?.statusCode == 200
    ) {
      enqueueSnackbar(resp?.data?.message || resp?.message, {
        variant: "success",
      });
      setOpen(false);
    } else {
      enqueueSnackbar(
        resp?.message ||
          resp?.data?.message ||
          resp?.error ||
          resp?.data?.error,
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    if (open && data) {
      setInputs((prev) => ({
        ...prev,
        tagId: type == "Add" ? data.id : data?.tag?.id,
        userId: type == "Add" ? "" : data?.user?.code,
        status: type == "Update" && data?.status,
      }));
      if (type == "Update") {
        setValue(dayjs(data.expiredAt));
      }
    }
  }, [open, data]);
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{
        sx: {
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: "10px",
        },
      }}
    >
      <DialogContent sx={{ width: 500 }}>
        <DialogTitle id="alert-dialog-title">
          {type == "Update"
            ? "Update Assign Profile tag"
            : "Assign Profile Tag"}
        </DialogTitle>
        <div>
          <TextField
            label="User RID"
            name="userId"
            value={inputs?.userId}
            onChange={handleChange}
            fullWidth
            size="small"
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          <TextField
            label="Tag ID"
            name="tagId"
            value={inputs?.tagId}
            onChange={handleChange}
            fullWidth
            size="small"
          />
        </div>
        {type == "Update" && (
          <div style={{ marginTop: "10px" }}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputs?.status}
                name="status"
                label="Status"
                onChange={handleChange}
              >
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
              </Select>
            </FormControl>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="primary"
          variant="outlined"
          sx={{ borderRadius: "10px", textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          className="gradientButton"
          autoFocus
          variant="contained"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
